import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import DeclinedDecision from './DeclinedDecision';
import DeferredDecision from './DeferredDecision';
import OfferedDecision from './OfferedDecision';
import Open from './OpenDecision';
import {
  useGetApplicationQuery,
  useGetFormalOffers,
} from '../../api/lendingApi/lendingApiQueries';
import { getAmplitudeDefaultEventProperties } from '../../utils/amplitudeEvents';
import ApplicationLoader from '../ApplicationLoader/ApplicationLoader';

type TDecisionStatus = 'declined' | 'deferred' | 'offered' | 'open';

const Decision = () => {
  const { application, applicationStatus, isApplicationRefetching } =
    useGetApplicationQuery();

  const { formalOffersData, formalOffersLoading } = useGetFormalOffers();

  useEffect(() => {
    tracking.ampli.stepLoaded({
      'Step name': 'Decision',
      ...getAmplitudeDefaultEventProperties(),
    });
  }, []);

  const decisionStatus = (): TDecisionStatus => {
    if (application?.status === 'declined') return 'declined';
    if (application?.status === 'deferred') return 'deferred';

    const isOfferedAndNotMicroApproval =
      application?.is_closed &&
      application?.status === 'offered' &&
      formalOffersData;

    if (isOfferedAndNotMicroApproval) return 'offered';

    return 'open';
  };

  if (
    !application ||
    applicationStatus === 'pending' ||
    formalOffersLoading ||
    isApplicationRefetching
  ) {
    return <ApplicationLoader />;
  }

  if (decisionStatus() === 'declined') {
    return <DeclinedDecision />;
  }

  if (decisionStatus() === 'deferred') {
    return <DeferredDecision />;
  }

  if (decisionStatus() === 'offered' && formalOffersData) {
    return <OfferedDecision formalOffersData={formalOffersData} />;
  }

  return <Open />;
};

export default Decision;
